import "./Main.css";
import Nav from "./Components/Nav/Nav";
import { Route, Routes } from 'react-router-dom';
import { useEffect, useState } from "react";
import ServerRequests from "../../Services/Api/ServersRequests.ts";
import Header from "./Components/Header/Header";
import RemoteAdmin from "./Games/SCPSL/RemoteAdmin/RemoteAdmin";
import GroupInfo from "./GroupInfo/GroupInfo";
import Settings from "./Settings/Settings.js";
import LogsSCP from "./Games/SCPSL/Logs/LogsSCP.js";
import Punishments from "./Games/SCPSL/Punishments/Punishments.js";
import HomePage from "./Home/HomePage.js";

const Home = () =>
{
  const [serverData, setServerData] = useState([]);

  const serverRequests = new ServerRequests();

  useEffect(() => {
    refresh();

    const serverRefresh = setInterval(() => {
      refresh();
    }, 10000);

    return () => { clearInterval(serverRefresh); };
  }, [])
  
  const refresh = () => {
    serverRequests.GetAllServers(setServerData);
  }
  
  const GetServer = (serverId) => {
    if(!serverId)
      return null;

    if(serverData.length == 0)
      return null;

    const servers = serverData.find(x => x.servers.find(y => y.id == serverId)).servers;

    if(servers) {
      const server = servers.find(x => x.id == serverId);

      return server;
    }

    return null;
  }

  return (
    <div className="content flex h-full">
      <Nav serverData={serverData} />
      <div className="wrapper">
        <Header GetServer={GetServer} serverData={serverData}/>
        <main>
          <Routes>
            <Route path="/" element={ <HomePage /> }/>
            <Route path="/scpsl-ra/:serverId" element={<RemoteAdmin GetServer={GetServer} />}/>
            <Route path="/scpsl-logs/:serverId" element={<LogsSCP />}/>
            <Route path="/scpsl-punishments/:serverId" element={<Punishments />}/>
            <Route path="/settings" element={<Settings />}/>
            <Route path="/group/:groupId" element={<GroupInfo refreshServers={refresh}/>}/>
          </Routes>
        </main>
      </div>
  </div>
  );
}

export default Home;